import o from "../../../decimal.js-light/decimal.js";
import { curry as u } from "./utils.js";
function f(r) {
  var n;
  return r === 0 ? n = 1 : n = Math.floor(new o(r).abs().log(10).toNumber()) + 1, n;
}
function m(r, n, e) {
  for (var t = new o(r), i = 0, a = []; t.lt(n) && i < 1e5; )
    a.push(t.toNumber()), t = t.add(e), i++;
  return a;
}
var l = u(function(r, n, e) {
  var t = +r, i = +n;
  return t + e * (i - t);
}), p = u(function(r, n, e) {
  var t = n - +r;
  return t = t || 1 / 0, (e - r) / t;
}), c = u(function(r, n, e) {
  var t = n - +r;
  return t = t || 1 / 0, Math.max(0, Math.min(1, (e - r) / t));
});
const g = {
  rangeStep: m,
  getDigitCount: f,
  interpolateNumber: l,
  uninterpolateNumber: p,
  uninterpolateTruncation: c
};
export {
  g as default
};
